import materialUI from "material-UI";
import styled from "styled-components";
import colors from "../../../../constants/color";

export const Container = styled.div`
  padding: 0 24px;
`;

export const TextField = styled(materialUI.TextField)`
  margin-top: 2px;
  label {
    display: none;
  }
  .MuiInputBase-adornedEnd {
    min-height: 42px;
  }
  .MuiInputBase-root {
    border-radius: 8px;
    .MuiAutocomplete-input {
      padding: 2px 4px;
    }
  }
  .Mui-focused {
    fieldset {
      border-color: ${colors.primary} !important;
    }
  }
  &.input-disabled {
    background-color: ${colors.gray100};
    input {
      color: ${colors.grey1};
    }
  }
  textarea {
    position: relative;
    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
      background: ${colors.LigthGrey};
    }
  }
`;
export const LabelText = styled.span`
  display: flex;
  flex-direction: row;
  font-size: 14px;
  line-height: 150%;
  color: #333333;
  font-family: Inter-Medium;
  margin-bottom: 8px;

  p {
    color: red;
    margin-left: 4px;
  }
`;

export const Autocomplete = styled(materialUI.Autocomplete)`
  overflow: hidden;
`;

export const SpaceY: any = styled.div`
  height: ${(props: any) => props.space}px !important;
`;

export const SpaceX: any = styled.div`
  width: ${(props: any) => props.space}px !important;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: end;
  grid-gap: 12px;
  width: 100%;

  button {
    padding: 8px;
    box-sizing: border-box;
    border-radius: 8px;
    font-size: 14px;
    cursor: pointer;
    font-weight: 500;
    height: 40px;
    width: 150px;
  }

  .primary {
    background-color: #2d5bff;
    color: white;
  }

  .disabled {
    opacity: 0.6 !important;
    cursor: not-allowed !important;
  }
`;
